import {FilterContext} from 'plugins/modules/filter/context/new';
import React, {FC, ReactNode, useMemo} from 'react';
import {useRouter} from 'next/router';
import {useGetFiltersProviderValue} from 'plugins/modules/filter/hooks/useGetFiltersProviderValue';
import {getCatalogSection} from 'modules/products/helpers';
import {useGetFiltersQueryData} from 'plugins/modules/filter/hooks/useGetFiltersQueryData';
import {useGetStockFiltersQuery} from 'modules/stock-x/services';

interface IProps {
    children: ReactNode;
}

export const StockXFilterProvider: FC<IProps> = ({children}) => {
    const router = useRouter();

    const query = useMemo(() => {
        const section = getCatalogSection(router.query.slug);

        return {
            section,
        };
    }, [router.query]);

    const filtersQueryData = useGetFiltersQueryData(query);

    const {data, refetch, isLoading, isFetching} = useGetStockFiltersQuery(filtersQueryData);

    const value = useGetFiltersProviderValue({data, refetch, isLoading, isFetching});

    return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
};
